define.alias("shared/utils/object-methods/object-map", "settings/utils/object-methods/object-map");